import { MutationKey } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { ClusterizationTaskId } from '@playq/services-beetle';
import { Environment } from '@playq/octopus-common';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

export type DeleteTaskPayloadType = {
  id: ClusterizationTaskId;
  env: Environment;
};

export const delteTaskKey: MutationKey = ['task', 'mutation', 'delete'];

export const useDeleteTask = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, DeleteTaskPayloadType>
) =>
  useEitherMutation(({ id, env }) => services2.audienceRequestsClusterizationService.delete(id, env), {
    mutationKey: delteTaskKey,
    ...options,
  });
